import React from "react";
import { useState, useEffect } from "react";
import { Link } from "react-scroll";
import ShinyText from "../Effects/ShinyText/ShinyText";
import LightRays from "../Effects/LightRays/LightRays";
import Header from "../Header/Header";
import AnimatedCounter from "./components/Counter/AnimatedCounter";
import "./Hero.css";

import hero_no_background from "../../assets/hero_no_background2.png";
import Heart from "../../assets/heart.png";
import Calories from "../../assets/calories.png";

import { motion } from "framer-motion";
import { useMediaQuery } from 'react-responsive';
import { sanityClient } from "../../sanity/client"; 

const Hero = () => {
  const transition = { type: "spring", duration: 3 };
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 999px)",
  });
  const heartVariants = {
    desktop: { right: "13rem"},
    tablet: { right: "7rem" }
  };

  const caloriesVariants = {
    desktop: { right: "10rem"},
    tablet: { right: "5rem" } 
  };

  const [ heroData, setHeroData ] = useState(null);

  useEffect(() => {
    sanityClient
    .fetch(`*[_type == "hero"][0]`)
    .then((data) => setHeroData(data))
    .catch((err) => console.log("Sanity fetch error:", err));
  }, []);


  return (
    <div className="hero" id="home">
      <div className="rays-hero">
        <LightRays
          raysOrigin="top-center"
          raysColor="#00ffff"
          raysSpeed={1}
          lightSpread={0.8}
          rayLength={1.2}
          followMouse={true}
          mouseInfluence={0.2}
          noiseAmount={0.1}
          distortion={0.05}
        />
      </div>

      <div className="blur hero-blur"></div>

      {/* ================= LEFT ================= */}
      <div className="left-h">
        <Header />

        <div className="the-best-ad">
          <motion.div
            initial={{ left: "165px" }}
            whileInView={{ left: "8px" }}
            transition={{ type: "tween", duration: 1 }}
          />
          <span>{heroData?.tagline}</span>
        </div>

        <div className="hero-text">
          <div>
            <span>
              <ShinyText text={heroData?.titleLine1?.shinyText} speed={7} />
            </span>
            <span className="stroke-text"> {heroData?.titleLine1?.strokeText}</span>
          </div>
          <div>
            <span className="stroke-text">{heroData?.titleLine2?.strokeText} </span>
            <span>
              <ShinyText text={heroData?.titleLine2?.shinyText} speed={7} />
            </span>
          </div>

          {/* ========== MOBILE IMAGE + FLOATING STATS ========== */}
          <div className="hero-image-wrapper-mobile">
            <img
              src={hero_no_background}
              alt="hero"
              className="hero-image-mobile"
            />

            <motion.div
              className="heart-rate floating"
              animate={{ y: [-5, 6, -6] }}
              transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
            >
              <img src={Heart} alt="" />
              <span>Ritmo Cardiaco</span>
              <span>145 bpm</span>
            </motion.div>

            <motion.div
              className="calories floating"
              animate={{ y: [6, -6, 6] }}
              transition={{ duration: 3, repeat: Infinity, repeatType: "mirror", ease: "easeInOut" }}
            >
              <img src={Calories} alt="" />
              <div>
                <span>Calorías quemadas</span>
                <span>450 Kcal</span>
              </div>
            </motion.div>
          </div>

          <div className="hero-text-description">
            <span>{heroData?.description}</span>
          </div>
        </div>

        <div className="figures">
          <div>
            <span>
              <AnimatedCounter from={0} to={heroData?.experienceYears || 0} duration={4} prefix="+" />
            </span>
            <span>Años experiencia</span>
          </div>
          <div>
            <span>
              <AnimatedCounter from={800} to={heroData?.studentsCount || 0} duration={3} prefix="+" />
            </span>
            <span>Alumnos formados</span>
          </div>
        </div>

        {heroData?.showCta && (
          <div className="hero-buttons">
            <Link
              to="contact"
              smooth={true}
              offset={-80}
              duration={600}
              className="btn"
            >
              {heroData?.ctaText || "Saber más"}
            </Link>
          </div>
        )}
      </div>

      {/* ================= RIGHT (DESKTOP ONLY) ================= */}
      <div className="right-h">
        <button className="btn btn-join">Join Now</button>

        <motion.div
          className="heart-rate desktop"
          initial={{ right: "-1rem" }}
          whileInView={ isTablet ? "tablet" : "desktop" }
          variants = {heartVariants}
          transition={transition}
        >
          <img src={Heart} alt="" />
          <span>Ritmo Cardiaco</span>
          <span>145 bpm</span>
        </motion.div>

        <img src={hero_no_background} alt="" className="hero-image" />

        <motion.div
          className="calories desktop"
          initial={{ right: "-1rem" }}
          whileInView={ isTablet ? "tablet" : "desktop" }
          variants={caloriesVariants}
          transition={transition}
        >
          <img src={Calories} alt="" />
          <div>
            <span>Calorías quemadas</span>
            <span>450 Kcal</span>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
